import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { AgentInsightService } from 'features/trend-detection/features/insight-agent/service/service'

export { AgentInsightService } from 'features/trend-detection/features/insight-agent/service/service'

export function useAgentInsightService(): AgentInsightService {
  const client = useApiClient()
  return useMemo(() => new AgentInsightService(client), [client])
}
